export default __webpack_public_path__ + "static/media/Setting_Phantasia.36832016.svg";